<template>
   <v-row class="mx-0 py-3 grey lighten-3">
      <v-col
        v-for="(icono,index) in iconos" :key="icono.id"
        cols="12"
        sm="12"
        md="6"
        lg="3"
        xl="2"
        :offset-xl="index == 0 ? '2': '0'"
        class="justify-start align-center d-flex flex-column"
      >
        <v-avatar color="primary" size="100">
          <v-img :src="renderImage(icono.image)" contain height="60" width="60"/>
        </v-avatar>
        <h3 class="text-center grey--text text-uppercase mt-10">{{icono.title}}</h3>
        <p class="text-center grey--text px-6">{{icono.subtitle}}</p>
      </v-col>
    </v-row>
</template>
<style lang="scss" scoped>
.grey--text {
  color: #424242 !important;
}
</style>
<script>
export default {
  props: ["iconos"],
  data() {
    return {
    };
  },
  methods: {
    renderImage(image) {
      if (image != null) {
        if (image.indexOf("https") < 0) {
          return "https://www.admin-uva.tidingo.com/" + image;
        } else {
          return image;
        }
      } else {
        return "";
      }
    },
  },  
};
</script>